import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { REACT_APP_API_NOTIFICATIONS } from '../../../utils/constants';

export const NotificationsGridItem = ({ notification, handleTotal }) => {
  const [isRead, setIsRead] = useState(notification.is_read);

  const handleReadMessage = async () => {
    setIsRead(true);
    const options = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: notification.email,
        createdAt: notification.rawCreatedAt
      })
    };

    if (!isRead) {
      handleTotal();
    }
    await fetch(REACT_APP_API_NOTIFICATIONS, options);
  };

  // Make sure it goes to the requested reviews-v2 route even if the DB still has old records
  const targetRoute =
    notification.route === '/reviews'
      ? '/reviews-v2'
      : notification.route || '/reviews-v2';

  return (
    <Link
      onClick={() => handleReadMessage(notification.id)}
      to={targetRoute}
      className="nav-link">
      <div className="media">
        <div
          className={
            'avatar avatar-sm ' + (!isRead ? 'avatar-online' : 'avatar-offline')
          }></div>
        <div className="media-body mg-l-15">
          <p dangerouslySetInnerHTML={{ __html: notification.title }} />
          <span>
            {notification.createdAt} by {notification.author}
          </span>
        </div>
      </div>
    </Link>
  );
};
